import { render, staticRenderFns } from "./TwitterTrending.vue?vue&type=template&id=4fb70cee"
import script from "./TwitterTrending.vue?vue&type=script&lang=js"
export * from "./TwitterTrending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports